module.exports = __webpack_public_path__ + "static/media/rhsc_logo_actual_size.33837545.svg";